import React from "react";
import {GlobalInfo} from "./context";
import {database} from "./config";
import {toast} from "react-toastify";
import {numberWithCommas, renderDate} from "./util";
import * as firebase from "firebase/app";
import {ACCOUNTS, saveAuditLog} from "./model/audit";
import {postToDiscord} from "./discord";
import {withTranslation} from "react-i18next";

function renderCharacterID(x) {
  if(!x || !x.substring) {
    return x
  }
  return x.substring(0, 1) + "\u00a0" + x.substring(1, 4) + "\u00a0" + x.substring(4, 7) + "\u00a0" + x.substring(7);
}

export class RequestsPage extends React.Component {

  completeWithdraw(request) {
    const { t } = this.props;
    database.runTransaction((transaction) => {
      let p = [];
      p.push(transaction.update(database.collection("users").doc(request.actorUserInfo.id), {
        pendingWithdrawals: firebase.firestore.FieldValue.increment(-request.amount),
        balanceIsk: firebase.firestore.FieldValue.increment(-request.amount),
      }));
      p.push(transaction.update(database.collection("users").doc(this.context.userInfo.id), {
        balanceIsk: firebase.firestore.FieldValue.increment(+request.amount),
      }));
      p.push(transaction.set(database.collection("payouts").doc(), {
        "actorUserInfo": this.context.userInfo,
        "targetUserInfo": request.actorUserInfo,
        "timestamp": Date.now(),
        "amountIsk": -request.amount,
        "amountPanda": 0,
        "account": ACCOUNTS.CORP_ISK_WITHDRAW_COUNTERPARTY,
      }));
      p.push(transaction.set(database.collection("payouts").doc(), {
        "actorUserInfo": this.context.userInfo,
        "targetUserInfo": this.context.userInfo,
        "timestamp": Date.now(),
        "amountIsk": +(request.amount*0.96),
        "amountPanda": 0,
        "account": ACCOUNTS.CORP_ISK_WITHDRAW_COUNTERPARTY,
      }));
      saveAuditLog(transaction, this.context.userInfo, request.actorUserInfo, {
        [ACCOUNTS.CORP_ISK_WITHDRAW_COUNTERPARTY]: -request.amount
      });
      saveAuditLog(transaction, this.context.userInfo, this.context.userInfo, {
        [ACCOUNTS.CORP_ISK_WITHDRAW_COUNTERPARTY]: +(request.amount*0.96)
      });
      p.push(transaction.delete(database.collection("requests").doc(request.id)));
      return Promise.all(p)
    }).then(() => {
      toast.success(t('pages:requests.messages.withdrawalCompleted'));
      postToDiscord({
        channel: "PAYOUT",
        username: "Pandemic Industry",
        content: `${this.context.userInfo.name} completed a payout for <@${request.actorUserInfo.id}> of ${numberWithCommas(request.amount)} ISK.`
      });
    })
  }

  cancelWithdraw(request) {
   database.runTransaction((transaction) => {
     let p = [];
     p.push(transaction.update(database.collection("users").doc(request.actorUserInfo.id), {
       pendingWithdrawals: firebase.firestore.FieldValue.increment(-request.amount),
       amountIsk: firebase.firestore.FieldValue.increment(+request.amount),
       //Does this need a line to add balance back
     }));
     p.push(transaction.delete(database.collection("requests").doc(request.id)));
     return Promise.all(p);
   });
  }

  render() {
    const { t } = this.props;
    return <div className={"container"}>
      <table className="table">
        <thead>
        <tr>
          <th>{t('pages:requests.tableHeaders.date')}</th>
          <th>{t('pages:requests.tableHeaders.pilot')}</th>
          <th>{t('pages:requests.tableHeaders.characterId')}</th>
          <th>{t('pages:requests.tableHeaders.type')}</th>
          <th>{t('pages:requests.tableHeaders.amount')}</th>
          <th>{t('pages:requests.tableHeaders.actions')}</th>
        </tr>
        </thead>
        <tbody>
        {this.context.requests.map(request => {
          return <tr key={request.id}>
            <td>{renderDate(request.timestamp)}</td>
            <td>{request.actorUserInfo.name}</td>
            <td>{renderCharacterID(request.characterID)}</td>
            <td>{request.type}</td>
            <td>{numberWithCommas(request.amount)} ({numberWithCommas(request.amount / 1.04)})</td>
            <td>
              <div className={"btn-group"}>
                <button className="btn btn-primary btn-sm" onClick={() => this.completeWithdraw(request)}>{t('pages:requests.actions.complete')}</button>
                <button className="btn btn-danger btn-sm" onClick={() => this.cancelWithdraw(request)}>{t('pages:requests.actions.cancel')}</button>
              </div>
            </td>
          </tr>
        })}
        </tbody>
      </table>
    </div>
  }
}

RequestsPage.contextType = GlobalInfo;

const TranslatedRequestsPage = withTranslation(['pages', 'common'])(RequestsPage);
export default TranslatedRequestsPage;